import React from "react";
import { Route, Routes } from "react-router-dom";
import OoraInfraDataset from "../Components/Oora Infra Data Set/ooraInfraData";
import AddOoraInfraDataset from "../Components/Oora Infra Data Set/addOoraInfraData";
import ViewOoraInfraDataset from "../Components/Oora Infra Data Set/viewOoraInfraData";
import UpdateOoraInfraDataset from "../Components/Oora Infra Data Set/updateOoraInfraData";

const OoraInfraDatasetRoutes = () => {
  return (
    <Routes>
      <Route path="/oora-infra-dataset" element={<OoraInfraDataset />} />
      <Route path="/oora-infra-dataset/add" element={<AddOoraInfraDataset />} />
      <Route path="/oora-infra-dataset/view/:id" element={<ViewOoraInfraDataset />} />
      <Route path="/oora-infra-dataset/update/:id" element={<UpdateOoraInfraDataset />} />
    </Routes>
  );
};

export default OoraInfraDatasetRoutes;